export default "__VITE_ASSET__DP04rBIh__"